import * as defaults from './default';
export * from './new';

export const defaultTheme = defaults.theme;
export const colors = defaults.colors;
export const PIE_CHART_COLORS = defaults.PIE_CHART_COLORS;
export const MIXED_BAR_CHART_COLOR = defaults.MIXED_BAR_CHART_COLOR;
export const SINGLE_BAR_CHART_COLOR = defaults.SINGLE_BAR_CHART_COLOR;
